var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('about-tile',{attrs:{"can-view-about":true,"can-view-chair":true,"can-view-sponsors":true}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }